export default "__VITE_ASSET__2GwJgPZe__"